import { LoggerBuilder } from '@packages/shared/core/common/logger/services/LoggerBuilder';
import { Logger } from '@packages/shared/core/common/logger/interfaces';
import { MarkdownToHtmlService } from '../interfaces';
import { PluginOptions } from '../entities';
import { UnifiedMarkdownToHtmlService } from './UnifiedMarkdownToHtmlService';

export class MarkdownToHtmlServiceBuilder {
  private readonly markdownToHtmlService: MarkdownToHtmlService;
  private readonly logger: Logger;

  constructor() {
    this.logger = new LoggerBuilder().addConsoleTransport().getResult();
    this.markdownToHtmlService = new UnifiedMarkdownToHtmlService(this.logger);
  }

  withUniqueHeadingIds() {
    this.markdownToHtmlService.addDangerousPlugin('rehype-slug');
    return this;
  }

  withExternalLinks(options: PluginOptions) {
    this.markdownToHtmlService.addDangerousPlugin(['rehype-external-links', options]);
    return this;
  }

  withConfiguredSanitizer(options: PluginOptions) {
    this.markdownToHtmlService.addDangerousPlugin(['rehype-sanitize', options]);
    return this;
  }

  getResult(): MarkdownToHtmlService {
    return this.markdownToHtmlService;
  }
}
